import React from "react";
import styled from "styled-components";
import { Timeline_Brand_Update } from "./Timeline_Brand_Update";

const TimelineTag = styled.div`
    display: grid;
    gap: 0.4rem;
`;

// Displays only the meaningful tag value and status transitions.
export const Timeline_Tag = (props) => {
    return (
        <TimelineTag>
            <Timeline_Brand_Update event={props.event} t={props.t} />
        </TimelineTag>
    );
};
